import React from "react"
import { Tag, Pagination } from "antd"
import { connect } from "react-redux"
import CopyToClipboard from "react-copy-to-clipboard"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
// import UserCard from "./userCard"
//import "./styles.css"
//import "../ContentList/style.css"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { Button, Card, CardBody, Badge } from "reactstrap"
import BootstrapTable from "react-bootstrap-table-next"
import { size, map } from "lodash"
import { Tooltip } from "antd"
import { deleteAppUser } from "appRedux/slices/usersList"
class UserList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      viewmodal: false,
      modal: false,
      orders: [],
      appCode: this.props.appCode || "CREATOR_NETWORK",
      fetchAllUsers: this.props?.filters?.fetchAllUsers || false,
      permissions: [],
      userColumns: [
        // {
        //   text: "id",
        //   dataField: "id",
        //   sort: true,
        //   hidden: true,
        //   formatter: (cellContent, user) => (
        //     <>
        //       {order.id}
        //     </>
        //   ),
        // },
        {
          dataField: "img",
          text: "#",
          style: {
            width: "5%",
          },
          formatter: (cellContent, user, rowIndex, y) => {
            return (
              <>
                <div className="avatar-xs">
                  <span className="avatar-title rounded-circle">
                    {user.name.charAt(0)}
                  </span>
                </div>
              </>
            )
          },
        },
        {
          dataField: "name",
          text: "Name",
          sort: true,
          formatter: (cellContent, user) => {
            return (
              <div className="d-flex flex-column">
                <div>{user.name}</div>
                <div>{user.email}</div>
              </div>
            )
          },
        },
        {
          dataField: "status",
          text: "Status",
          sort: true,
          formatter: (cellContent, user) => {
            return (
              <div>
                <Badge
                  className={
                    user.status === "1"
                      ? "badge-soft-success ms-1 rounded-pill px-3"
                      : "badge-soft-warning ms-1 rounded-pill px-3"
                  }
                >
                  <div className="font-size-12 p-1">
                    {user.status === "1" ? "Active" : "Disabled"}
                  </div>
                </Badge>
              </div>
            )
          },
        },
        {
          dataField: "roles",
          isDummyField: true,
          hidden: this.props?.filters?.fetchAllUsers ? true : false,
          text: "Roles",
          sort: true,
          formatter: (cellContent, user) => {
            // let applicationsData = user.applications.filter((item) => item.applicationCode === this.state.appCode);
            // let filteredApp = applicationsData && applicationsData.length>0 ? applicationsData[0] : {};
            // let permissionsArr = !_.isEmpty(filteredApp) ? (filteredApp["roles"] && filteredApp["roles"].length > 0 ?  filteredApp["roles"] : []) : []
            return (
              <div>
                {map(
                  user.roles,
                  (tag, index) =>
                    index < 1 && (
                      <Badge className="badge-soft-info ms-1">
                        <div className="font-size-12 p-1">{tag}</div>
                      </Badge>
                    )
                )}
                {size(user.roles) > 1 && (
                  <Badge className="badge-soft-success ms-1">
                    <Tooltip
                      placement="right"
                      title={user.roles.slice(1, user.roles.length).map(a => (
                        <div>{a}</div>
                      ))}
                    >
                      <div className="font-size-12 p-1">
                        +{size(user.roles) - 1} more
                      </div>
                    </Tooltip>
                  </Badge>
                )}
              </div>
            )
          },
        },
        {
          dataField: "permissions",
          isDummyField: true,
          hidden: this.props?.filters?.fetchAllUsers ? true : false,
          text: "Permissions",
          sort: true,
          formatter: (cellContent, user) => {
            // let applicationsData = user.applications.filter((item) => item.applicationCode === this.state.appCode);
            // let filteredApp = applicationsData && applicationsData.length>0 ? applicationsData[0] : {};
            // let permissionsArr = !_.isEmpty(filteredApp) ? (filteredApp["include_permissions"] && filteredApp["include_permissions"].length > 0 ?  filteredApp["include_permissions"] : []) : []
            return (
              <div>
                {map(
                  user.permissions,
                  (tag, index) =>
                    index < 1 && (
                      <Badge className="badge-soft-info ms-1">
                        <div className="font-size-12 p-1">{tag}</div>
                      </Badge>
                    )
                )}
                {size(user.permissions) > 1 && (
                  <Badge className="badge-soft-success ms-1">
                    <Tooltip
                      placement="right"
                      title={user.permissions
                        .slice(1, user.permissions.length)
                        .map(a => (
                          <div>{a}</div>
                        ))}
                    >
                      <div className="font-size-12 p-1">
                        +{size(user.permissions) - 1} more
                      </div>
                    </Tooltip>
                  </Badge>
                )}
              </div>
            )
          },
        },
        {
          dataField: "applications",
          isDummyField: true,
          hidden: this.props?.filters?.fetchAllUsers ? false : true,
          text: "Applications",
          sort: true,
          formatter: (cellContent, user) => {
            return (
              <div>
                {map(
                  user.applications,
                  (tag, index) =>
                    index < 1 && (
                      <Badge className="badge-soft-info ms-1">
                        <div className="font-size-12 p-1">{tag}</div>
                      </Badge>
                    )
                )}
                {size(user.applications) > 1 && (
                  <Badge className="badge-soft-success ms-1">
                    <Tooltip
                      placement="right"
                      title={user.applications
                        .slice(1, user.applications.length)
                        .map(a => (
                          <div>{a}</div>
                        ))}
                    >
                      <div className="font-size-12 p-1">
                        +{size(user.applications) - 1} more
                      </div>
                    </Tooltip>
                  </Badge>
                )}
              </div>
            )
          },
        },
        {
          dataField: "menu",
          isDummyField: true,
          editable: false,
          text: "Actions",
          formatter: (cellContent, user) => (
            <div className="d-flex align-items-center gap-3">
              <div role="button" className="text-success">
                <i
                  className="bx bx-edit-alt me-1 font-size-18 fw-bold"
                  id="edittooltip"
                  onClick={e => {
                    e.stopPropagation(),
                      e.preventDefault(),
                      this.props.handleEditClick(user)
                  }}
                ></i>
              </div>
              <div>
                <CopyToClipboard
                  text={user.userUUID}
                  onCopy={e => {
                    toastr.success("Copied sucessfully!")
                  }}
                >
                  <Tooltip title="Copy User ID">
                    <i
                      className="bx bx-copy me-1 font-size-18 fw-bold"
                      role="button"
                    />
                  </Tooltip>
                </CopyToClipboard>
              </div>
              <div role="button" className="text-danger">
                <i
                  className="bx bx-trash-alt font-size-18 fw-bold"
                  id="deletetooltip"
                  onClick={e => {
                    // if (
                    //   !this.props.currentUser?.permissions?.includes(
                    //     "EDIT_COMMUNITY_MANAGEMENT"
                    //   )
                    // ) {
                    //   toastr.error(NO_PERMISSION_MESSAGE)
                    //   return
                    // }
                    e.stopPropagation(),
                      e.preventDefault(),
                      this.handleDeleteUser(user)
                  }}
                ></i>
              </div>
            </div>
            // <Button
            //   type="button"
            //   color="primary"
            //   className="btn-sm btn-rounded"
            //   onClick={this.toggleViewModal}
            // >
            //   View Details
            // </Button>
          ),
        },
      ],
    }
    // this.toggle = this.toggle.bind(this)
    // this.toLowerCase1 = this.toLowerCase1.bind(this)
  }

  handleDeleteUser = user => {
    this.props.dispatch(
      deleteAppUser({ id: user.userUUID, appCode: this.props.appCode })
    )
  }

  render() {
    const { userList } = this.props
    const defaultSorted = [
      {
        dataField: "name",
        order: "asc",
      },
    ]
    return (
      <>
        {this.props.total &&
          this.props.userList &&
          this.props.userList.length > 0 && (
            <div style={{ textAlign: "center" }} className="mb-2">
              <Tag color="geekblue">
                Showing <b>{this.props.userList.length}</b> of{" "}
                <b>{this.props.total}</b> Users
              </Tag>
            </div>
          )}
        {this.props.userList.length > 0 && (
          <div className="">
            <Card>
              <CardBody>
                <ToolkitProvider
                  keyField="id"
                  data={userList}
                  columns={this.state.userColumns}
                  bootstrap4
                  search
                >
                  {toolkitProps => (
                    <React.Fragment>
                      <div className="table-responsive">
                        <BootstrapTable
                          {...toolkitProps.baseProps}
                          // {...paginationTableProps}
                          responsive
                          defaultSorted={defaultSorted}
                          bordered={false}
                          striped={false}
                          // selectRow={selectRow}
                          classes={
                            "table align-middle table-nowrap table-check"
                          }
                          headerWrapperClasses={"table-light"}
                        />
                      </div>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              </CardBody>
            </Card>
          </div>
        )}
        <div className="d-flex justify-content-end mb-2">
          <Pagination
            style={{ marginTop: "1rem", listStyle: "none", display: "flex" }}
            onChange={val => this.props.onPageChange(val)}
            defaultCurrent={this.props.currentPage}
            total={this.props.total < 10000 ? this.props.total : 10000}
            pageSize={this.props.pageSize}
            showSizeChanger={false}
          />
        </div>
      </>
    )
  }
}

function mapStateToProps(store, ownProps) {
  return {
    userList: _.get(store, "appUser.user"),
  }
}

export default connect(mapStateToProps)(UserList)
